import { render, staticRenderFns } from "./ComingSoonPage.vue?vue&type=template&id=6afd375e&scoped=true"
import script from "./ComingSoonPage.vue?vue&type=script&lang=js"
export * from "./ComingSoonPage.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonPage.vue?vue&type=style&index=0&id=6afd375e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afd375e",
  null
  
)

export default component.exports